// extracted by mini-css-extract-plugin
module.exports = {"container":"reset_container__1aGdQ","form":"reset_form__3_Drj"};